import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import Head from '../../layout/head/Head';
import AuthTenantPageError from '../error/AuthTenantPageError';
import AuthTenantLoader from '../loaders/AuthTenantLoader';
import Content from '../../layout/content/Content';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, Row, RSelect } from '../../components/Component';
import { RETRIEVE_SPECIFIC_SALES_REP_DISPATCH_DETAILS_API, RETRIEVE_SPECIFIC_SALES_REP_TENANT_ORDER_API, SALES_REP_CONFIRM_DISPATCH_DELIVERY_API, SALES_REP_DELETE_ORDER_ITEM_API, SALES_REP_UPDATE_ORDER_STATUS_API } from '../../api/api_data';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_retrieve_specific_sales_rep_tenant_order_details, loading_retrieve_specific_sales_rep_tenant_order_details, reset_retrieve_specific_sales_rep_tenant_order_details, success_retrieve_specific_sales_rep_tenant_order_details } from '../../reducers/auth_tenant/retrieve_specific_sales_rep_tenant_order_details_Slice';
import { RETRIVE_SPECIFIC_TENANT_ORDER_SUCCESS_MSG, RETRIVE_SPECIFIC_TENANT_ORDER_DETAILS_ERROR_MSG, RETRIVE_TENANT_DISPATCH_DETAILS_ERROR_MSG, RETRIVE_TENANT_DISPATCH_DETAILS_SUCCESS_MSG, SALES_REP_CONFIRM_DISPATCH_DELIVERY_SUCCESS_MSG, SALES_REP_CONFIRM_DISPATCH_DELIVERY_ERROR_MSG, UPDATE_TENANT_ORDER_STATUS_DETAILS_ERROR_MSG, UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG, DELETE_ORDER_ITEM_ERROR_MSG, DELETE_ORDER_ITEM_SUCCESS_MSG } from '../../utils/error_success_messages';
import * as app_consts from "../../utils/app_consts";
import { addThreeDots, formatNumber, formatToSentenceCase, joinWithCommas, messageToast } from '../../utils/Utils';
import { useSelector } from 'react-redux';
import CardTabs from '../components/cards/CardTabs';
import moment from 'moment';
import { Alert, Badge, Card, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalFooter, ModalHeader, Spinner, UncontrolledDropdown } from 'reactstrap';
import AuthTenantNoData from '../error/AuthTenantNoData';
import OrderPDF from '../../components/pdf/OrderPDF';
import { PDFViewer, pdf } from '@react-pdf/renderer';
import LabelText from '../components/text/LabelText';
import { fail_retrieve_tenant_dispatch_details, loading_retrieve_tenant_dispatch_details, reset_retrieve_tenant_dispatch_details, success_retrieve_tenant_dispatch_details } from '../../reducers/auth_tenant/retrieve_tenant_dispatch_details_Slice';
import DispatchPDF from '../../components/pdf/DispatchPDF';
import { fail_sales_rep_confirm_dispatch_delivery, loading_sales_rep_confirm_dispatch_delivery, reset_sales_rep_confirm_dispatch_delivery, success_sales_rep_confirm_dispatch_delivery } from '../../reducers/auth_tenant/sales_rep_confirm_dispatch_delivery_Slice';
import TextInput from '../components/inputs/TextInput';
import { fail_update_tenant_order_status, loading_update_tenant_order_status, reset_update_tenant_order_status, success_update_tenant_order_status } from '../../reducers/auth_tenant/update_tenant_order_status_Slice';
import YesNoModal from '../../components/modal/YesNoModal';
import { fail_delete_order_item, loading_delete_order_item, reset_delete_order_item, success_delete_order_item } from '../../reducers/auth_tenant/delete_order_item_Slice';
import { AnimatePresence, motion } from 'framer-motion';

const inital_confirm_delivery_form_data = { delivery_document: "", comment: "" };

const OrderListingDetails = ({ tenant_info, user_info }) => {

 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [order_data, setOrderData] = useState([]);
 const { order_ref_no } = useParams();
 const [activeCardTab, setActiveCardTab] = useState("Main Info");
 const dispatch = useDispatch();
 const [orderItemsPerPage] = useState(10);
 const [currentOrderItemsPage, setCurrentOrderItemsPage] = useState(1);
 const [orderHistoryPerPage] = useState(10);
 const [currentOrderHistoryPage, setCurrentOrderHistoryPage] = useState(1);
 const [view_dispatch_details_modal, setViewDispatchDetailsModal] = useState(false);
 const [delete_modal, setDeleteModal] = useState(false);
 const [selected_delete, setSelectedDelete] = useState("");
 const [delete_error, setDeleteError] = useState("");

 const indexOfLastOrderItem = currentOrderItemsPage * orderItemsPerPage;
 const indexOfFirstOrderItem = indexOfLastOrderItem - orderItemsPerPage;
 const currentOrderItems = order_data?.order_items?.slice(indexOfFirstOrderItem, indexOfLastOrderItem);

 const indexOfLastOrderHistory = currentOrderHistoryPage * orderHistoryPerPage;
 const indexOfFirstOrderHistory = indexOfLastOrderHistory - orderHistoryPerPage;
 const currentOrderHistory = order_data?.history?.slice(indexOfFirstOrderHistory, indexOfLastOrderHistory);

 const [view_order_history_modal, setViewOrderHistoryModal] = useState(false);
 const [selected_order_history_details, setSelectedOrderHistoryDetails] = useState([]);

 const [retrieve_dispatch_detail_error, setRetrieveDispatchDetailError] = useState("");
 const [retrieve_dispatch_detail_loading, setRetrieveDispatchDetailLoading] = useState(true);
 const [viewDispatchDetailsActiveCardTab, setViewDispatchDetailsActiveCardTab] = useState("Dispatch Info");
 const [dispatch_details, setDispatchDetails] = useState([]);

 const [confirm_delivery_modal, setConfirmDeliveryModal] = useState(false);
 const [confirm_delivery_form_data, setConformDeliveryFormData] = useState(inital_confirm_delivery_form_data);
 const [confirm_delivery_error, setConfirmDeliveryError] = useState("");
 const [confirm_delivery_loading, setConfirmDeliveryLoading] = useState(false);
 const fileInputRef = useRef(null); // Reference for file input
 const [sm, updateSm] = useState(false);

 const [update_order_status_modal, setUpdateOrderStatusModal] = useState(false);
 const [update_order_status_error, setUpdateOrderStatusError] = useState("");
 const [update_order_status_loading, setUpdateOrderStatusLoading] = useState(false);
 const [order_status_formData, setOrderStatusFormData] = useState({ order_ref_number: order_ref_no, status: "" });

 const [update_order_status_data, setUpdateOrderStatusData] = useState({ message: "", header: "", status: "" });

 const [expandedItems, setExpandedItems] = useState({});
 const totalPages = Math.ceil(currentOrderItems?.length / orderItemsPerPage);

 // Toggle mobile item expansion
 const toggleExpand = (id) => {
  setExpandedItems(prev => ({
   ...prev,
   [id]: !prev[id]
  }));
 };


 // Card Tabs
 const view_dispatch_details_tabs = [
  {
   tabName: "Dispatch Info"
  },
  {
   tabName: "Products"
  },
  {
   tabName: "PDF"
  }
 ];

 // Retreive Product
 useEffect(() => {
  retreive_order_details();
 }, []);

 // Retrieve Product
 const retreive_order_details = () => {
  dispatch(tenant_auth_actions_helper(loading_retrieve_specific_sales_rep_tenant_order_details, success_retrieve_specific_sales_rep_tenant_order_details, fail_retrieve_specific_sales_rep_tenant_order_details, RETRIVE_SPECIFIC_TENANT_ORDER_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_ORDER_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_SALES_REP_TENANT_ORDER_API}/${order_ref_no}`));
 };

 // Listener
 const retrieve_specific_sales_rep_tenant_order_details_listener = useSelector((state) => state.retrieve_specific_sales_rep_tenant_order_details.retrieve_specific_sales_rep_tenant_order_details);

 useEffect(() => {
  if (retrieve_specific_sales_rep_tenant_order_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_specific_sales_rep_tenant_order_details_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_specific_sales_rep_tenant_order_details_listener.status === app_consts.FAIL)
    {
     setError(retrieve_specific_sales_rep_tenant_order_details_listener.message);
     messageToast(retrieve_specific_sales_rep_tenant_order_details_listener.message, app_consts.FAIL);
    } else if (retrieve_specific_sales_rep_tenant_order_details_listener.status === app_consts.SUCCESS)
    {
     setOrderData(retrieve_specific_sales_rep_tenant_order_details_listener.data);

    }
    dispatch(reset_retrieve_specific_sales_rep_tenant_order_details());
   }
  }
 }, [retrieve_specific_sales_rep_tenant_order_details_listener]);

 // Card Tabs
 const tabs = [
  {
   tabName: "Main Info", icon: "file-docs"
  },
  {
   tabName: "Order Items", icon: "package"
  },
  {
   tabName: "Order History", icon: "clock"
  },
  {
   tabName: "Dispatches", icon: "truck"
  },
  {
   tabName: "Order PDF", icon: "file-pdf"
  }
 ];

 const open_view_order_history_modal = (message, timestamp) => {
  setViewOrderHistoryModal(true);
  setSelectedOrderHistoryDetails({ message: message, timestamp: timestamp });
 };

 const closr_view_order_history_modal = () => {
  setViewOrderHistoryModal(false);
  setSelectedOrderHistoryDetails([]);
 };

 const [currentDispatchItemsPage, setCurrentDispatchItemsPage] = useState(1);
 const [dispatchHistoryPerPage] = useState(10);

 const indexOfLastDispatchItem = currentDispatchItemsPage * dispatchHistoryPerPage;
 const indexOfFirstDispatchItem = indexOfLastDispatchItem - dispatchHistoryPerPage;
 const currentDispatchItems = order_data?.dispatches?.slice(indexOfFirstDispatchItem, indexOfLastDispatchItem);

 const open_view_dispatch_details_modal = (dispatch_ref_no) => {
  setViewDispatchDetailsModal(true);
  setRetrieveDispatchDetailError("");
  // setRetrieveDispatchDetailData;
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_dispatch_details, success_retrieve_tenant_dispatch_details, fail_retrieve_tenant_dispatch_details, RETRIVE_TENANT_DISPATCH_DETAILS_ERROR_MSG, RETRIVE_TENANT_DISPATCH_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_SALES_REP_DISPATCH_DETAILS_API}/${dispatch_ref_no}`));
 };

 // Listener
 const retrieve_tenant_dispatch_details_listener = useSelector((state) => state.retrieve_tenant_dispatch_details.retrieve_tenant_dispatch_details);

 useEffect(() => {
  if (retrieve_tenant_dispatch_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_dispatch_details_listener.status === app_consts.LOADING)
   {
    setRetrieveDispatchDetailLoading(true);
    setRetrieveDispatchDetailError("");
   } else
   {
    setRetrieveDispatchDetailLoading(false);
    if (retrieve_tenant_dispatch_details_listener.status === app_consts.FAIL)
    {
     setRetrieveDispatchDetailError(retrieve_tenant_dispatch_details_listener.message);
     messageToast(retrieve_tenant_dispatch_details_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_dispatch_details_listener.status === app_consts.SUCCESS)
    {
     setDispatchDetails(retrieve_tenant_dispatch_details_listener.data);
    }
    dispatch(reset_retrieve_tenant_dispatch_details());
   }
  }
 }, [retrieve_tenant_dispatch_details_listener]);

 const close_view_dispatch_details_modal = () => {
  setViewDispatchDetailsModal(false);
  setRetrieveDispatchDetailError("");
 };

 const open_confirm_delivery_modal = () => {
  setConfirmDeliveryModal(true);
  setConformDeliveryFormData(inital_confirm_delivery_form_data);
  setConfirmDeliveryError("");
 };

 const close_confirm_delivery_modal = () => {
  setConfirmDeliveryModal(false);
  setConformDeliveryFormData(inital_confirm_delivery_form_data);
  setConfirmDeliveryError("");
 };


 const handleImageUpload = (event) => {
  const file = event.target.files[0];

  if (file)
  {
   const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];

   if (!allowedTypes.includes(file.type))
   {
    messageToast("Please select a valid file (PNG, JPEG, JPG, PDF).", app_consts.FAIL);
    return;
   }

   setConformDeliveryFormData({ ...confirm_delivery_form_data, ["delivery_document"]: file });
  }
 };


 // Confirm Sales Rep Delivery 
 const handleConfirmDispatchDelivery = () => {
  setConfirmDeliveryError("");
  const dispatch_data = { ...confirm_delivery_form_data, dispatch_ref_no: dispatch_details?.dispatch_ref_no };
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_sales_rep_confirm_dispatch_delivery, success_sales_rep_confirm_dispatch_delivery, fail_sales_rep_confirm_dispatch_delivery, SALES_REP_CONFIRM_DISPATCH_DELIVERY_ERROR_MSG, SALES_REP_CONFIRM_DISPATCH_DELIVERY_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${SALES_REP_CONFIRM_DISPATCH_DELIVERY_API}`, dispatch_data));
 };
 // Listener
 const sales_rep_confirm_dispatch_delivery_listener = useSelector((state) => state.sales_rep_confirm_dispatch_delivery.sales_rep_confirm_dispatch_delivery);

 useEffect(() => {
  if (sales_rep_confirm_dispatch_delivery_listener.status !== app_consts.IDLE)
  {
   if (sales_rep_confirm_dispatch_delivery_listener.status === app_consts.LOADING)
   {
    setConfirmDeliveryLoading(true);
    setConfirmDeliveryError("");
   } else
   {
    setConfirmDeliveryLoading(false);
    if (sales_rep_confirm_dispatch_delivery_listener.status === app_consts.FAIL)
    {
     setConfirmDeliveryError(sales_rep_confirm_dispatch_delivery_listener.message);
     messageToast(sales_rep_confirm_dispatch_delivery_listener.message, app_consts.FAIL);
    } else if (sales_rep_confirm_dispatch_delivery_listener.status === app_consts.SUCCESS)
    {
     setDispatchDetails(sales_rep_confirm_dispatch_delivery_listener.data);
     retreive_order_details();
     close_confirm_delivery_modal();
    }
    dispatch(reset_sales_rep_confirm_dispatch_delivery());
   }
  }
 }, [sales_rep_confirm_dispatch_delivery_listener]);

 const open_update_order_status_modal = (message, header, status) => {
  setUpdateOrderStatusModal(true);
  setUpdateOrderStatusError("");
  setOrderStatusFormData([]);
  setUpdateOrderStatusData({ ...update_order_status_data, message: message, header: header, status: status });
 };

 const close_update_order_status_modal = () => {
  setUpdateOrderStatusModal(false);
  setUpdateOrderStatusError("");
  setOrderStatusFormData([]);
  setUpdateOrderStatusData({ ...update_order_status_data, message: "", header: "", status: "" });
 };

 const handleUpdateOrderStatusSubmit = () => {
  setUpdateOrderStatusError("");
  const dispatch_params = { ...update_order_status_data, order_ref_number: order_data?.order_ref_number };
  dispatch(tenant_auth_actions_helper(loading_update_tenant_order_status, success_update_tenant_order_status, fail_update_tenant_order_status, UPDATE_TENANT_ORDER_STATUS_DETAILS_ERROR_MSG, UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${SALES_REP_UPDATE_ORDER_STATUS_API}`, dispatch_params));
 };
 // Listener
 const update_tenant_order_status_listener = useSelector((state) => state.update_tenant_order_status.update_tenant_order_status);

 useEffect(() => {
  if (update_tenant_order_status_listener.status !== app_consts.IDLE)
  {
   if (update_tenant_order_status_listener.status === app_consts.LOADING)
   {
    setUpdateOrderStatusLoading(true);
    setUpdateOrderStatusError("");
   } else
   {
    setUpdateOrderStatusLoading(false);
    if (update_tenant_order_status_listener.status === app_consts.FAIL)
    {
     setUpdateOrderStatusError(update_tenant_order_status_listener.message);
     messageToast(update_tenant_order_status_listener.message, app_consts.FAIL);
    } else if (update_tenant_order_status_listener.status === app_consts.SUCCESS)
    {
     retreive_order_details();
     messageToast(UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG, app_consts.SUCCESS);
     close_update_order_status_modal();
    }
    dispatch(reset_update_tenant_order_status());
   }
  }
 }, [update_tenant_order_status_listener]);

 const open_delete_modal = (delete_item) => {
  setDeleteModal(true);
  setSelectedDelete(delete_item);
 };

 const close_delete_modal = () => {
  setDeleteModal(false);
  setSelectedDelete("");
 };

 const handle_order_item_delete = () => {
  setDeleteError("");
  dispatch(tenant_auth_actions_helper(loading_delete_order_item, success_delete_order_item, fail_delete_order_item, DELETE_ORDER_ITEM_ERROR_MSG, DELETE_ORDER_ITEM_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${SALES_REP_DELETE_ORDER_ITEM_API}`, { order_item_id: selected_delete?.id }));
 };

 // Listener
 const delete_order_item_listener = useSelector((state) => state.delete_order_item.delete_order_item);

 useEffect(() => {
  if (delete_order_item_listener.status !== app_consts.IDLE)
  {
   if (delete_order_item_listener.status === app_consts.LOADING)
   {
    setDeleteError("");
   } else
   {
    if (delete_order_item_listener.status === app_consts.FAIL)
    {
     setDeleteError(delete_order_item_listener.message);
     messageToast(delete_order_item_listener.message, app_consts.FAIL);
    } else if (delete_order_item_listener.status === app_consts.SUCCESS)
    {
     messageToast(DELETE_ORDER_ITEM_SUCCESS_MSG, app_consts.SUCCESS);
     close_delete_modal();
     retreive_order_details();
    }
    dispatch(reset_delete_order_item());
   }
  }
 }, [delete_order_item_listener]);

 const handleOpenPdf = async () => {
  const blob = await pdf(
   <OrderPDF page_data={order_data} tenant_info={tenant_info} />
  ).toBlob();

  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl); // or download it
 };

 const handleDownload = async () => {
  const blob = await pdf(
   <OrderPDF page_data={order_data} tenant_info={tenant_info} />
  ).toBlob();

  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = `${order_ref_no}.pdf`;
  a.click();
 };

 const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Order Details | ${order_ref_no}` : `Order Details | ${order_ref_no}`} />
   <Content>
    <BlockHead size="sm">
     <BlockBetween className="g-3">
      <BlockHeadContent>
       <BlockTitle page>{`Order Details | ${order_ref_no}`}</BlockTitle>
       <Link to={`${process.env.PUBLIC_URL}/${tenant_info?.url_prefix}/orders`}>
        <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
         <Icon name="arrow-left"></Icon>
         <span>Back</span>
        </Button>
       </Link>
       <Link to={`${process.env.PUBLIC_URL}/${tenant_info?.url_prefix}/orders`}>
        <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
         <Icon name="arrow-left"></Icon>
        </Button>
       </Link>
      </BlockHeadContent>
      <BlockHeadContent>
       <div className="toggle-wrap nk-block-tools-toggle">
        <Button
         className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
         onClick={() => updateSm(!sm)}
        >
         <Icon name="menu-alt-r"></Icon>
        </Button>
        <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
         <ul className="nk-block-tools g-3"> {
          order_data?.status === app_consts.PENDING_SUBMISSION_LOWER && (
           <>
            <li>
             <UncontrolledDropdown>
              <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light mt-2">
               <span>Actions</span>
               <Icon name="chevron-right" className="dd-indc"></Icon>
              </DropdownToggle>
              <DropdownMenu end>
               <ul className="link-list-opt no-bdr">
                {
                 order_data?.order_items && order_data?.order_items?.length > 0 && (
                  <>
                   {
                    order_data?.approval_type === app_consts.SINGLE ?
                     <>
                      <li>
                       <DropdownItem
                        tag="a"
                        href="#dropdownitem"
                        onClick={(ev) => {
                         ev.preventDefault();
                         open_update_order_status_modal("Are you Sure that you want to Submit the Order?", "Submit Order", app_consts.PENDING_APPROVAL_LOWER);
                        }}
                       >
                        <span>Submit Order for Approval</span>
                       </DropdownItem>
                      </li>
                     </>
                     :
                     <>
                      {
                       order_data?.approval_type === app_consts.DOUBLE && (
                        <>
                         <li>
                          <DropdownItem
                           tag="a"
                           href="#dropdownitem"
                           onClick={(ev) => {
                            ev.preventDefault();
                            open_update_order_status_modal("Are you Sure that you want to Submit the Order?", "Submit Order", app_consts.PENDING_REVIEW_LOWER);
                           }}
                          >
                           <span>Submit Order for Review</span>
                          </DropdownItem>
                         </li>
                        </>
                       )
                      }
                     </>
                   }
                  </>
                 )
                }
                <li>
                 <DropdownItem
                  tag="a"
                  href="#dropdownitem"
                  onClick={(ev) => {
                   ev.preventDefault();
                   open_update_order_status_modal("Are you Sure that you want to Cancel the Order?", "Cancel Order", app_consts.CANCELLED_LOWER);
                  }}
                 >
                  <span>Cancel Order</span>
                 </DropdownItem>
                </li>
               </ul>
              </DropdownMenu>
             </UncontrolledDropdown>
            </li>
           </>
          )
         }
         </ul>
        </div>
       </div>
      </BlockHeadContent>
     </BlockBetween>
    </BlockHead>
    <Block>
     <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
    </Block>
    {
     loading ?
      <>
       <AuthTenantLoader tenant_info={tenant_info} />
      </>
      :
      <>
       {
        error ?
         <>
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
         </>
         :
         <>
          {
           order_data ?
            <>
             {
              activeCardTab === "Main Info" && (
               <>
                <div className="card-inner bg-white">
                 <Block>
                  <BlockHead>
                   <BlockTitle tag="h5">Main Information</BlockTitle>
                  </BlockHead>
                  <div className="profile-ud-list">
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Reference No.</span>
                     <span className="profile-ud-value">{order_data?.order_ref_number || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Destination</span>
                     <span className="profile-ud-value">{order_data?.order_name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Sales Rep</span>
                     <span className="profile-ud-value">{order_data?.sales_rep?.name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Warehouse Name</span>
                     <span className="profile-ud-value">{order_data?.warehouse_site_name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Order Created</span>
                     <span className="profile-ud-value">{order_data?.inserted_at ? moment(order_data?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Status</span>
                     <span className="profile-ud-value">
                      <span className="tb-odr-status">
                       <Badge
                        color={
                         order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER
                          ? "success"
                          : "warning"
                        }
                        className="badge-dot"
                       >
                        {order_data?.status ? formatToSentenceCase(order_data?.status)?.toUpperCase() : "--"}
                       </Badge>
                      </span></span>
                    </div>
                   </div>
                  </div>
                  {
                   order_data?.agency && (
                    <>
                     <BlockHead>
                      <BlockTitle tag="h5">Agency Details</BlockTitle>
                     </BlockHead>
                     <div className="profile-ud-list">
                      <div className="profile-ud-item">
                       <div className="profile-ud wider">
                        <span className="profile-ud-label">Reference No.</span>
                        <span className="profile-ud-value">{order_data?.agency?.name || "--"}</span>
                       </div>
                      </div>
                      <div className="profile-ud-item">
                       <div className="profile-ud wider">
                        <span className="profile-ud-label">Destination</span>
                        <span className="profile-ud-value">{order_data?.agency?.mobile_number || "--"}</span>
                       </div>
                      </div>
                      <div className="profile-ud-item">
                       <div className="profile-ud wider">
                        <span className="profile-ud-label">Sales Rep</span>
                        <span className="profile-ud-value">{order_data?.agency?.email_address || "--"}</span>
                       </div>
                      </div>
                     </div>
                    </>
                   )
                  }
                 </Block>
                </div>
               </>
              )
             }
             {
              activeCardTab === "Order Items" && (
               <>
                <div className="card-inner">
                 <Block>
                  <BlockHead>
                   <BlockTitle tag="h5">Order Items ({currentOrderItems.length})</BlockTitle>
                   {currentOrderItems.length > orderItemsPerPage && (
                    <div className="d-flex justify-content-between align-items-center mt-2">
                     <small>Showing {indexOfFirstOrderItem + 1}-{Math.min(indexOfLastOrderItem, currentOrderItems?.length)} of {currentOrderItems.length}</small>
                     <div className="pagination">
                      <button
                       className="btn btn-icon btn-sm"
                       disabled={currentOrderItemsPage === 1}
                       onClick={() => setCurrentOrderItemsPage(prev => prev - 1)}
                      >
                       <Icon name="chevron-left" />
                      </button>
                      <span className="mx-2">Page {currentOrderItemsPage} of {totalPages}</span>
                      <button
                       className="btn btn-icon btn-sm"
                       disabled={currentOrderItemsPage === totalPages}
                       onClick={() => setCurrentOrderItemsPage(prev => prev + 1)}
                      >
                       <Icon name="chevron-right" />
                      </button>
                     </div>
                    </div>
                   )}
                  </BlockHead>

                  {/* Desktop Table View - Original Styling */}
                  <div className="d-none d-md-block">
                   <div className="nk-tb-list is-separate is-medium mb-3">
                    <DataTableHead className="nk-tb-item">
                     <DataTableRow>
                      <span className="sub-text">Product</span>
                     </DataTableRow>
                     <DataTableRow>
                      <span className="sub-text">Color</span>
                     </DataTableRow>
                     <DataTableRow>
                      <span className="sub-text">Size</span>
                     </DataTableRow>
                     <DataTableRow>
                      <span className="sub-text">Units</span>
                     </DataTableRow>
                     <DataTableRow>
                      <span className="sub-text">Unit Value (ZMW)</span>
                     </DataTableRow>
                     <DataTableRow>
                      <span className="sub-text">Total Value (ZMW)</span>
                     </DataTableRow>
                     <DataTableRow>
                      <span className="sub-text">Dispatched</span>
                     </DataTableRow>
                     <DataTableRow size="md">
                      <span className="sub-text">Status</span>
                     </DataTableRow>
                     {order_data?.status === app_consts.PENDING_SUBMISSION_LOWER && (
                      <DataTableRow>
                       <span className="sub-text">Action</span>
                      </DataTableRow>
                     )}
                    </DataTableHead>

                    {currentOrderItems?.map((item) => (
                     <DataTableItem key={item.id}>
                      <DataTableRow>
                       <div className="user-card">
                        <div className="user-info">
                         <span className="tb-lead">
                          {item?.product?.name || "--"}
                         </span>
                         <span>{item?.product?.category || "--"} | {item?.product?.product_type || "--"}</span>
                        </div>
                       </div>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-product">
                        <span className="tb-sub">{item?.color || "--"}</span>
                       </span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.size || "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.units || "0"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.unit_value ? parseFloat(item?.unit_value)?.toFixed(2) : "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.total_value ? parseFloat(item?.total_value)?.toFixed(2) : "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.units_loaded || "0"}</span>
                      </DataTableRow>
                      <DataTableRow size="md">
                       <span className="tb-odr-status">
                        <Badge
                         color={item?.status === app_consts.DISPATCHED_LOWER ? "success" : "warning"}
                         className="badge-dot"
                        >
                         {item ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                        </Badge>
                       </span>
                      </DataTableRow>
                      {order_data?.status === app_consts.PENDING_SUBMISSION_LOWER && (
                       <DataTableRow>
                        <Icon
                         name="trash-fill"
                         className="text-danger"
                         style={{ fontSize: "20px", cursor: "pointer" }}
                         onClick={() => open_delete_modal(item)}
                        />
                       </DataTableRow>
                      )}
                     </DataTableItem>
                    ))}
                   </div>
                  </div>

                  {/* Mobile Card View */}
                  <div className="d-md-none">
                   {currentOrderItems?.map((item) => (
                    <div
                     key={item.id}
                     className="card card-bordered mb-3"
                     style={{
                      borderRadius: '8px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                      position: 'relative'
                     }}
                    >
                     {order_data?.status === app_consts.PENDING_SUBMISSION_LOWER && (
                      <button
                       className="btn btn-icon btn-sm"
                       style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        zIndex: 1,
                        padding: '4px',
                        background: 'rgba(255,255,255,0.8)',
                        borderRadius: '50%'
                       }}
                       onClick={(e) => {
                        e.stopPropagation();
                        open_delete_modal(item);
                       }}
                      >
                       <Icon name="trash-fill" className="text-danger" style={{ fontSize: "16px" }} />
                      </button>
                     )}

                     <div
                      className="card-inner p-3 mt-3"
                      onClick={() => toggleExpand(item.id)}
                      style={{ cursor: 'pointer' }}
                     >
                      <div className="d-flex justify-content-between align-items-center">
                       <div style={{ maxWidth: 'calc(100% - 100px)' }}>
                        <h6 className="mb-0 text-truncate">{item?.product?.name || "--"}</h6>
                        <small className="text-soft">
                         {item?.product?.category || "--"} | {item?.product?.product_type || "--"}
                        </small>
                       </div>
                       <Badge
                        color={item?.status === app_consts.DISPATCHED_LOWER ? "success" : "warning"}
                        className="badge-dot"
                       >
                        {formatToSentenceCase(item?.status)?.toUpperCase() || "--"}
                       </Badge>
                      </div>

                      <div className="row g-2 mt-2">
                       <div className="col-6">
                        <span className="sub-text d-block">Units</span>
                        <span>{item?.units || "0"}</span>
                       </div>
                       <div className="col-6">
                        <span className="sub-text d-block">Total Value (ZMW)</span>
                        <span>{item?.total_value ? parseFloat(item?.total_value)?.toFixed(2) : "--"}</span>
                       </div>
                      </div>

                      <div className="text-center mt-2">
                       <button
                        className="btn btn-link btn-sm p-0"
                        onClick={(e) => {
                         e.stopPropagation();
                         toggleExpand(item.id);
                        }}
                       >
                        {expandedItems[item.id] ? (
                         <span className="text-soft">View Less <Icon name="chevron-up" /></span>
                        ) : (
                         <span className="text-soft">View More <Icon name="chevron-down" /></span>
                        )}
                       </button>
                      </div>

                      <AnimatePresence>
                       {expandedItems[item.id] && (
                        <motion.div
                         initial={{ opacity: 0, height: 0 }}
                         animate={{ opacity: 1, height: 'auto' }}
                         exit={{ opacity: 0, height: 0 }}
                         transition={{ duration: 0.3 }}
                         className="mt-3"
                        >
                         <div className="border-top pt-3">
                          <div className="row g-2">
                           <div className="col-6">
                            <span className="sub-text d-block">Color</span>
                            <span>{item?.color || "--"}</span>
                           </div>
                           <div className="col-6">
                            <span className="sub-text d-block">Size</span>
                            <span>{item?.size || "--"}</span>
                           </div>
                           <div className="col-6">
                            <span className="sub-text d-block">Unit Value (ZMW)</span>
                            <span>{item?.unit_value ? parseFloat(item?.unit_value)?.toFixed(2) : "--"}</span>
                           </div>
                           <div className="col-6">
                            <span className="sub-text d-block">Dispatched</span>
                            <span>{item?.units_loaded || "0"}</span>
                           </div>
                          </div>
                         </div>
                        </motion.div>
                       )}
                      </AnimatePresence>
                     </div>
                    </div>
                   ))}
                  </div>

                  {/* Pagination Controls */}
                  {currentOrderItems.length > orderItemsPerPage && (
                   <div className="d-flex justify-content-center mt-3">
                    <ul className="pagination">
                     <li className={`page-item ${currentOrderItemsPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentOrderItemsPage(1)}>
                       <Icon name="chevron-double-left" />
                      </button>
                     </li>
                     <li className={`page-item ${currentOrderItemsPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentOrderItemsPage(prev => Math.max(1, prev - 1))}>
                       <Icon name="chevron-left" />
                      </button>
                     </li>

                     {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= 5)
                      {
                       pageNum = i + 1;
                      } else if (currentOrderItemsPage <= 3)
                      {
                       pageNum = i + 1;
                      } else if (currentOrderItemsPage >= totalPages - 2)
                      {
                       pageNum = totalPages - 4 + i;
                      } else
                      {
                       pageNum = currentOrderItemsPage - 2 + i;
                      }

                      return (
                       <li key={pageNum} className={`page-item ${currentOrderItemsPage === pageNum ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentOrderItemsPage(pageNum)}>
                         {pageNum}
                        </button>
                       </li>
                      );
                     })}

                     <li className={`page-item ${currentOrderItemsPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentOrderItemsPage(prev => Math.min(totalPages, prev + 1))}>
                       <Icon name="chevron-right" />
                      </button>
                     </li>
                     <li className={`page-item ${currentOrderItemsPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentOrderItemsPage(totalPages)}>
                       <Icon name="chevron-double-right" />
                      </button>
                     </li>
                    </ul>
                   </div>
                  )}
                 </Block>
                </div>

                <YesNoModal openModal={delete_modal} setOpenModal={setDeleteModal} modalTitle={`Delete Order Item ${selected_delete && (`${selected_delete?.product?.name} (${selected_delete?.product?.category})`)} ?`} errAmend={delete_error} setErrAmend={setDeleteError} buttonCancel="No" buttonConfirm="Yes" modalDescription={`Are you Sure that you want to Delete ${selected_delete && (`${selected_delete?.product?.name} (${selected_delete?.product?.category})`)} ?`} succFunc={handle_order_item_delete} />
               </>
              )
             }
             {
              activeCardTab === "Order History" && (
               <>
                <div className="card-inner">
                 <Block>
                  <BlockHead>
                   <BlockTitle tag="h5">Order History</BlockTitle>
                  </BlockHead>
                  <div className="nk-tb-list is-separate is-medium mb-3">
                   <DataTableHead className="nk-tb-item">
                    <DataTableRow>
                     <span className="sub-text">Message</span>
                    </DataTableRow>
                    <DataTableRow >
                     <span className="sub-text">Timestamp</span>
                    </DataTableRow>
                    <DataTableRow>
                     <span className="sub-text">Action</span>
                    </DataTableRow>
                   </DataTableHead>
                   {/*Head*/}
                   {currentOrderHistory.length > 0
                    ? currentOrderHistory.map((item) => (
                     <DataTableItem key={item.timestamp}>
                      <DataTableRow>
                       <span className="tb-sub">{item?.message ? addThreeDots(item?.message, 60) : "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-product">
                        <span className="tb-sub">{item?.timestamp ? moment(item?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                       </span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                       <div className="tb-odr-btns d-none d-sm-inline">
                        <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_order_history_modal(item?.message, item?.timestamp)}>
                         View
                        </Button>
                       </div>
                       <Button className="btn-pd-auto d-sm-none" onClick={() => open_view_order_history_modal(item?.message, item?.timestamp)}>
                        <Icon name="chevron-right"></Icon>
                       </Button>
                      </DataTableRow>
                     </DataTableItem>
                    ))
                    : null}
                  </div>
                 </Block>
                </div>

                {/* View History Modal */}
                <Modal isOpen={view_order_history_modal} toggle={closr_view_order_history_modal} className="modal-dialog-centered" size={"lg"}>
                 <ModalHeader toggle={closr_view_order_history_modal}>Order History Details Details</ModalHeader>
                 <ModalBody>
                  <Row className="g-4">
                   <LabelText text={selected_order_history_details?.message || "--"} label="User" />
                   <LabelText text={selected_order_history_details?.timestamp ? moment(selected_order_history_details?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"} label="Timestamp" />
                  </Row>
                 </ModalBody>
                </Modal>


               </>
              )
             }

             {
              activeCardTab === "Dispatches" && (
               <>
                {
                 order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ?
                  <>
                   <div className="card-inner">
                    <Block>
                     <BlockHead>
                      <BlockTitle tag="h5">Dispatches</BlockTitle>
                     </BlockHead>
                     {order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ? (
                      order_data?.dispatches?.length > 0 ? (
                       <>
                        {/* Desktop Table View (≥768px) - RESTORED */}
                        <div className="d-none d-md-block">
                         <div className="nk-tb-list is-separate is-medium mb-3">
                          <DataTableHead className="nk-tb-item">
                           <DataTableRow><span className="sub-text">Dispatch No</span></DataTableRow>
                           <DataTableRow><span className="sub-text">Transporter</span></DataTableRow>
                           <DataTableRow><span className="sub-text">Truck Driver</span></DataTableRow>
                           <DataTableRow><span className="sub-text">License Plate</span></DataTableRow>
                           <DataTableRow><span className="sub-text">Status</span></DataTableRow>
                           <DataTableRow><span className="sub-text">Action</span></DataTableRow>
                          </DataTableHead>

                          {currentDispatchItems.map((item) => (
                           <DataTableItem key={item.dispatch_ref_no}>
                            <DataTableRow>
                             <span className="tb-sub">{item?.dispatch_ref_no || "--"}</span>
                            </DataTableRow>
                            <DataTableRow>
                             <span className="tb-sub">{item?.transporter_name || "--"}</span>
                            </DataTableRow>
                            <DataTableRow>
                             <span className="tb-sub">{item?.truck_driver_name || "--"}</span>
                            </DataTableRow>
                            <DataTableRow>
                             <span className="tb-sub">{item?.truck_licence_plate || "--"}</span>
                            </DataTableRow>
                            <DataTableRow>
                             <span className="tb-odr-status">
                              <Badge
                               color={item?.status === app_consts.DISPATCHED_LOWER ? "success" : "warning"}
                               className="badge-dot"
                              >
                               {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                              </Badge>
                             </span>
                            </DataTableRow>
                            <DataTableRow>
                             <Button
                              color="primary"
                              size="sm"
                              className="btn btn-dim"
                              onClick={() => open_view_dispatch_details_modal(item?.dispatch_ref_no)}
                             >
                              View
                             </Button>
                            </DataTableRow>
                           </DataTableItem>
                          ))}
                         </div>
                        </div>

                        {/* Mobile Card View (<768px) with bottom-right View button */}
                        <div className="d-md-none">
                         {currentDispatchItems.map((item) => (
                          <div
                           key={item.dispatch_ref_no}
                           className="card card-bordered mb-3"
                           style={{
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            position: 'relative'
                           }}
                          >
                           <div className="card-inner p-3">
                            <div className="d-flex justify-content-between align-items-start">
                             <div>
                              <h6 className="mb-1">Dispatch #{item?.dispatch_ref_no || "--"}</h6>
                              <Badge
                               color={item?.status === app_consts.DISPATCHED_LOWER ? "success" : "warning"}
                               className="badge-dot"
                              >
                               {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                              </Badge>
                             </div>
                            </div>

                            <div className="row g-2 mt-2">
                             <div className="col-6">
                              <span className="sub-text d-block">Transporter</span>
                              <span>{item?.transporter_name || "--"}</span>
                             </div>
                             <div className="col-6">
                              <span className="sub-text d-block">Driver</span>
                              <span>{item?.truck_driver_name || "--"}</span>
                             </div>
                             <div className="col-12">
                              <span className="sub-text d-block">License Plate</span>
                              <span>{item?.truck_licence_plate || "--"}</span>
                             </div>
                            </div>

                            {/* Bottom-right View button */}
                            <div className="text-end mt-2">
                             <Button className="btn btn-outline-primary btn-sm"
                              onClick={() => open_view_dispatch_details_modal(item?.dispatch_ref_no)}
                              style={{
                               minWidth: '80px'
                              }}>
                              View
                             </Button>
                            </div>
                           </div>
                          </div>
                         ))}
                        </div>
                       </>
                      ) : (
                       <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Dispatches Found."} />
                      )
                     ) : (
                      <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Dispatches Found."} />
                     )}
                    </Block>
                   </div>

                   {/* View Dispatch Details Card */}
                   < Modal isOpen={view_dispatch_details_modal} className="modal-dialog-centered" size={"xl"} fullscreen >
                    <ModalHeader toggle={retrieve_dispatch_detail_loading ? "" : close_view_dispatch_details_modal}>Dispatch Details</ModalHeader>
                    <ModalBody>
                     {
                      retrieve_dispatch_detail_loading ?
                       <>
                        <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                         <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Dispatch Details...</div>
                         <div className="nk-loader mt-2  w-70 m-auto "></div>
                        </div>
                       </>
                       :
                       <>
                        {
                         retrieve_dispatch_detail_error ?
                          <>
                           <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                            <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{retrieve_dispatch_detail_error}</div>
                           </div>
                          </>
                          :
                          <>
                           <Block>
                            {
                             !dispatch_details?.delivery_proof_url && (
                              <>
                               <BlockBetween>
                                <div>

                                </div>
                                <Button color="primary" onClick={open_confirm_delivery_modal}>
                                 Confirm Delivery
                                </Button>
                               </BlockBetween>
                              </>
                             )
                            }
                            <CardTabs cardTabs={view_dispatch_details_tabs} activeCardTab={viewDispatchDetailsActiveCardTab} setActiveCardTab={setViewDispatchDetailsActiveCardTab} />
                           </Block>
                           {
                            viewDispatchDetailsActiveCardTab === "Dispatch Info" && (
                             <>
                              <div className="card-inner bg-white">
                               <Block>
                                <BlockHead>
                                 <BlockTitle tag="h5">Dispatch Info</BlockTitle>
                                </BlockHead>
                                <div className="profile-ud-list">
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Dispatch Ref No</span>
                                   <span className="profile-ud-value">{dispatch_details?.dispatch_ref_no || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Transporter Name</span>
                                   <span className="profile-ud-value">{dispatch_details?.transporter_name || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Driver Name</span>
                                   <span className="profile-ud-value">{dispatch_details?.truck_driver_name || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">License Plate</span>
                                   <span className="profile-ud-value">{dispatch_details?.truck_licence_plate || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Trailer One</span>
                                   <span className="profile-ud-value">{dispatch_details?.trailer_one || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Trailer Two</span>
                                   <span className="profile-ud-value">{dispatch_details?.trailer_two || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Delivery Date</span>
                                   <span className="profile-ud-value">{dispatch_details?.delivery_date_time ? moment(dispatch_details?.delivery_date_time).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Dispatch Date</span>
                                   <span className="profile-ud-value">{dispatch_details?.dispatch_date_time ? moment(dispatch_details?.dispatch_date_time).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Comments</span>
                                   <span className="profile-ud-value">{dispatch_details?.customer_feedback_comments || "--"}</span>
                                  </div>
                                 </div>
                                 <div className="profile-ud-item">
                                  <div className="profile-ud wider">
                                   <span className="profile-ud-label">Status</span>
                                   <span className="profile-ud-value">
                                    <span className="tb-odr-status">
                                     <Badge
                                      color={
                                       dispatch_details?.status === app_consts.DISPATCHED_LOWER
                                        ? "success"
                                        : "warning"
                                      }
                                      className="badge-dot"
                                     >
                                      {dispatch_details?.status ? formatToSentenceCase(dispatch_details?.status)?.toUpperCase() : "--"}
                                     </Badge>
                                    </span></span>
                                  </div>
                                 </div>
                                </div>
                               </Block>
                              </div>
                             </>
                            )
                           }
                           {
                            viewDispatchDetailsActiveCardTab === "Products" && (
                             <>
                              <div className="card-inner bg-white">
                               <Block>
                                <BlockHead>
                                 <BlockTitle tag="h5">Products</BlockTitle>
                                </BlockHead>
                                <BlockBetween>
                                </BlockBetween>
                                <div className="nk-tb-list is-separate is-medium mb-3">
                                 <DataTableHead className="nk-tb-item">
                                  <DataTableRow><span className="sub-text">Brand</span></DataTableRow>
                                  <DataTableRow><span className="sub-text">Product</span></DataTableRow>
                                  <DataTableRow><span className="sub-text">Color</span></DataTableRow>
                                  <DataTableRow><span className="sub-text">Packet Size</span></DataTableRow>
                                  {
                                   dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                    <>
                                     <DataTableRow><span className="sub-text">Dispatched</span></DataTableRow>
                                     <DataTableRow size="lg"><span className="sub-text">Total Value ZMW</span></DataTableRow>
                                    </>
                                    :
                                    <>
                                     <DataTableRow><span className="sub-text">Remainder</span></DataTableRow>
                                     <DataTableRow><span className="sub-text">To Dispatch</span></DataTableRow>
                                    </>
                                  }

                                 </DataTableHead>
                                 {/* Existing Items */}
                                 {
                                  dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                   <>
                                    {dispatch_details?.products?.length > 0 &&
                                     dispatch_details?.products?.map((item) => {


                                      const product_value = order_data?.order_items?.find((search_item) => search_item?.size === item?.size && search_item?.product_id === item?.product_id && search_item?.color === item?.color);

                                      return (
                                       <DataTableItem key={item.id}>
                                        <DataTableRow><span className="tb-lead">{item?.category || "--"}</span></DataTableRow>
                                        <DataTableRow><span className="tb-lead">{item?.name || "--"}</span></DataTableRow>
                                        <DataTableRow><span className="tb-sub">{item?.color || "--"}</span></DataTableRow>
                                        <DataTableRow><span className="tb-sub">{item?.size || "--"}</span></DataTableRow>

                                        {
                                         dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                          <>
                                           <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                                           <DataTableRow>
                                            <div className="user-card">
                                             <div className="user-info">
                                              <span className="tb-lead">{product_value?.unit_value ? `${formatNumber(product_value?.unit_value * item?.units)}` : "--"}</span>
                                              <span>{product_value?.total_value ? `${formatNumber(product_value?.unit_value)}` : ""}</span>
                                             </div>
                                            </div>
                                           </DataTableRow>
                                          </>
                                          :
                                          <>
                                           <DataTableRow><span className="tb-sub">{item?.remainder || "0"}</span></DataTableRow>
                                           <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                                          </>
                                        }
                                       </DataTableItem>
                                      );
                                     }
                                     )}
                                   </>
                                   :
                                   <>
                                    <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Products have been Dispatched"} />
                                   </>
                                 }
                                </div>
                               </Block>
                              </div>
                             </>
                            )
                           }
                           {
                            viewDispatchDetailsActiveCardTab === "PDF" && (
                             <>
                              {
                               dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                <>
                                 {
                                  dispatch_details?.delivery_proof_url ? (
                                   <div className="card-inner">
                                    <Block>
                                     <BlockHead>
                                      <BlockTitle tag="h5">Dispatch Document</BlockTitle>
                                     </BlockHead>
                                     <div style={{ height: "90vh", width: "100%" }} className="border-2 border-text-gray-400">
                                      {dispatch_details.delivery_proof_url.endsWith(".pdf") ? (
                                       <embed
                                        src={dispatch_details.delivery_proof_url}
                                        type="application/pdf"
                                        width="100%"
                                        height="100%"
                                       />
                                      ) : (
                                       <img
                                        src={dispatch_details.delivery_proof_url}
                                        alt="Dispatch Proof"
                                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                       />
                                      )}
                                     </div>
                                    </Block>
                                   </div>
                                  )
                                   :
                                   <>
                                    <PDFViewer height="100%" width="100%" showToolbar>
                                     <DispatchPDF order_details={order_data} dispatch_details={dispatch_details} tenant_info={tenant_info} />
                                    </PDFViewer>
                                   </>
                                 }
                                </>
                                :
                                <>
                                 <AuthTenantNoData tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Products have been Dispatched"} />
                                </>
                              }
                             </>
                            )
                           }
                          </>
                        }
                       </>
                     }
                    </ModalBody>
                   </Modal>
                   {/* Confirm Delivery Modal */}
                   {/* Modal */}
                   <Modal isOpen={confirm_delivery_modal} className="modal-dialog-top">
                    <ModalHeader
                     toggle={confirm_delivery_loading ? "" : close_confirm_delivery_modal}
                    >
                     Confirm Dispatch
                    </ModalHeader>
                    <ModalBody>

                     <Row className="g-4 mb-4">
                      <Col size="12">
                       <div className="form-group">
                        <label className="form-label">Comment</label>
                        <textarea
                         value={confirm_delivery_form_data?.comment}
                         onChange={(e) => setConformDeliveryFormData({ ...confirm_delivery_form_data, comment: e.target.value })}
                         className="form-control-xl form-control no-resize" />
                       </div>
                      </Col>
                      <div className="product-thumb" style={{ height: '250px', width: '100%', position: 'relative', marginBottom: 30 }}>
                       <label className="form-label">Delivery Proof Document</label>
                       {confirm_delivery_form_data?.delivery_document ? (
                        <>
                         {confirm_delivery_form_data.delivery_document.type.startsWith('image') ? (
                          <img
                           src={URL.createObjectURL(confirm_delivery_form_data.delivery_document)}
                           alt="Uploaded Document"
                           style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          />
                         ) : (
                          <embed
                           src={URL.createObjectURL(confirm_delivery_form_data.delivery_document)}
                           type="application/pdf"
                           width="100%"
                           height="100%"
                          />
                         )}

                         <button
                          type="button"
                          onClick={() => setConformDeliveryFormData({ ...confirm_delivery_form_data, delivery_document: null })}
                          style={{
                           position: 'absolute',
                           top: '10px',
                           right: '10px',
                           backgroundColor: 'gray',
                           color: 'white',
                           border: 'none',
                           padding: '5px 10px',
                           cursor: 'pointer'
                          }}
                         >
                          Reupload
                         </button>
                        </>
                       ) : (
                        <label
                         htmlFor="imageUpload"
                         style={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#f0f0f0',
                          textAlign: 'center',
                          border: '1px dashed #ccc',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          fontFamily: 'Arial, sans-serif',
                          flexDirection: 'column',
                          cursor: 'pointer'
                         }}
                        >
                         <p style={{ margin: 0, padding: '5px' }}>Click to Select Document</p>
                        </label>
                       )}

                       <input
                        type="file"
                        id="imageUpload"
                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                        style={{ display: 'none' }}
                        onChange={handleImageUpload}
                        ref={fileInputRef} // Assign ref
                       />
                      </div>
                     </Row>
                     {confirm_delivery_error && (
                      <div className="mb-3 w-100">
                       <Alert color="danger" className="alert-icon">
                        <Icon name="alert-circle" /> {confirm_delivery_error}{" "}
                       </Alert>
                      </div>
                     )}
                    </ModalBody>
                    <ModalFooter className="bg-light">
                     <BlockBetween>
                      <BlockHeadContent>
                      </BlockHeadContent>
                      <BlockHeadContent>
                       <Button color="primary" disabled={confirm_delivery_loading || !(confirm_delivery_form_data?.comment && confirm_delivery_form_data?.delivery_document)} onClick={handleConfirmDispatchDelivery}>
                        {confirm_delivery_loading ? <Spinner size="sm" color="light" /> : "Confirm Delivery"}
                       </Button>
                      </BlockHeadContent>
                     </BlockBetween>
                    </ ModalFooter>
                   </Modal>
                  </>
                  :
                  <>
                   <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Dispatches Found."} />
                  </>
                }
                {/* Update Order Status  Modal*/}
               </>
              )
             }
             {
              activeCardTab === "Order PDF" && (
               <>
                {
                 order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ?
                  <>
                   <div className="card-inner">
                    <Block>
                     <BlockHead>
                      <BlockTitle tag="h5">Order PDF</BlockTitle>
                     </BlockHead>
                     <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                      {isMobile ? (
                       <div style={{ display: 'flex', gap: '16px' }}>
                        <motion.button
                         whileHover={{ scale: 1.05 }}
                         whileTap={{ scale: 0.95 }}
                         onClick={handleOpenPdf}
                         style={{
                          padding: '12px 24px',
                          backgroundColor: '#6576ff',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '16px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          boxShadow: '0 4px 6px rgba(101, 118, 255, 0.2)'
                         }}
                        >
                         <Icon name="external-link" />
                         Open PDF
                        </motion.button>

                        <motion.button
                         whileHover={{ scale: 1.05 }}
                         whileTap={{ scale: 0.95 }}
                         onClick={handleDownload}
                         style={{
                          padding: '12px 24px',
                          backgroundColor: 'white',
                          color: '#6576ff',
                          border: '1px solid #6576ff',
                          borderRadius: '6px',
                          fontSize: '16px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                         }}
                        >
                         <Icon name="download" />
                         Download
                        </motion.button>
                       </div>
                      )
                       :
                       <>

                        <PDFViewer height="100%" width="100%" showToolbar>
                         <OrderPDF page_data={order_data} tenant_info={tenant_info} />
                        </PDFViewer>
                       </>
                      }
                     </div>
                    </Block>
                   </div>
                  </>
                  :
                  <>
                   <AuthTenantNoData tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Order Status is 'Approved'"} />
                  </>
                }
               </>
              )
             }
             {/* Update Order Status  Modal*/}
             < Modal isOpen={update_order_status_modal} className="modal-dialog-centered" size={"md"} >
              <ModalHeader toggle={update_order_status_loading ? "" : close_update_order_status_modal}>{update_order_status_data?.header}</ModalHeader>
              <ModalBody>
               <ModalBody>
                <p>
                 {update_order_status_data?.message}
                </p>
               </ModalBody>
               <Row className="g-4">
                {update_order_status_error && (
                 <div className="mb-3 w-100">
                  <Alert color="danger" className="alert-icon">
                   <Icon name="alert-circle" /> {update_order_status_error}{" "}
                  </Alert>
                 </div>
                )}
               </Row>
              </ModalBody>
              <ModalFooter className="bg-light">
               <BlockBetween>
                <BlockHeadContent>
                 <Button className={"mx-2"} onClick={close_update_order_status_modal} color="gray">
                  No
                 </Button>

                 <Button className={"mx-2"} onClick={handleUpdateOrderStatusSubmit} disabled={
                  update_order_status_loading ||
                  !(update_order_status_data?.status)
                 } color="primary">
                  {update_order_status_loading ? <Spinner size="sm" color="light" /> : "Confirm"}
                 </Button>
                </BlockHeadContent>
               </BlockBetween>
              </ ModalFooter>
             </Modal>
            </>
            :
            <>
             <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Order Data Found"} />
            </>
          }
         </>
       }
      </>
    }
   </Content>
  </>
 );
};

export default OrderListingDetails;